import { WebSocketClient, IWSServerUnreadEventSchema } from '@cian/chats-api/lib/browser-entry';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger/shared';
import { Session } from './session';
import { delay } from '../../../utils/delay';

export class Notifications {
  /**
   * Является ли объект уничтоженным, необходим для того, чтобы прервать цикл реконектов
   *
   * @private
   * @memberof Notifications
   */
  private destroyed = false;
  private session: Session | null = null;

  /**
   * Предохранитель, который защищает от возможного DDOS в апишку
   *
   * @private
   * @memberof Notifications
   */
  private canOpenConnection = true;

  private notificationsHandlerId: string | null = null;
  private onCloseHandlerId: string;

  // eslint-disable-next-line @typescript-eslint/no-parameter-properties
  public constructor(private socket: WebSocketClient, private httpApi: IHttpApi, private logger: ILogger) {}

  // Истанбул не дает отключить покрытие на цикл. Причины зачем нужен игнор ниже.
  /* istanbul ignore next */
  public async connect() {
    if (!this.canOpenConnection) {
      return;
    }

    this.destroyed = false;

    this.session = Session.createSession(this.socket, this.httpApi, this.logger);

    let trys = 4;

    while (trys--) {
      try {
        this.canOpenConnection = false;
        await this.openConnection();

        break;
      } catch (error) {
        this.logger.error(error);

        await delay(10000);

        continue;
      }
    }

    this.canOpenConnection = true;

    if (!this.onCloseHandlerId) {
      this.onCloseHandlerId = this.socket.addEventListener('close', this.onClose);
    }

    await this.session.update();
  }

  public close() {
    this.destroyed = true;

    /* istanbul ignore next */
    if (this.session) {
      Session.removeSession();

      this.session = null;
    }

    /* istanbul ignore next */
    if (this.notificationsHandlerId) {
      this.socket.removeEventListener('message', this.notificationsHandlerId);
    }

    this.socket.removeEventListener('close', this.onCloseHandlerId);

    this.socket.close();
  }

  public onNotifications(callback: (count: number | null) => void) {
    this.notificationsHandlerId = this.socket.addEventListener('message', (socketEvent: MessageEvent) => {
      const event: IWSServerUnreadEventSchema = JSON.parse(socketEvent.data);

      /* istanbul ignore next */
      if (event.type === 'unread') {
        callback(event.unread);
      }
    });
  }

  // Истангбул хочет, чтобы цикл завершился, но это бессмысленно, так как на последнем проходе с ошибкой
  // она будет выброшена
  /* istanbul ignore next */
  private async openConnection() {
    for (let retryCount = 0; retryCount < 4; retryCount++) {
      try {
        await this.socket.open();

        return;
      } catch (error) {
        if (retryCount === 3) {
          throw error;
        }

        await delay(1000);
      }
    }
  }

  private onClose = () => {
    /* istanbul ignore next */
    if (!this.destroyed) {
      /* istanbul ignore next */
      if (this.session) {
        Session.removeSession();
      }

      this.connect();
    }
  };
}
